import {createContext, useState} from "react";

export const DivisionContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [divisions, setDivisions] = useState([]);

    // Make the context object:
    const divisionContext = {
        divisions,
        setDivisions,
    };

    // pass the value in provider and return
    return <DivisionContext.Provider value={divisionContext}>{children}</DivisionContext.Provider>;
}

export const {Consumer} = DivisionContext;
